/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { App } from '../../models/app';

export interface AppsControllerFindOneByAppIdentifier$Params {

/**
 * The app id
 */
  appIdentifier: string;
}

export function appsControllerFindOneByAppIdentifier(http: HttpClient, rootUrl: string, params: AppsControllerFindOneByAppIdentifier$Params, context?: HttpContext): Observable<StrictHttpResponse<App>> {
  const rb = new RequestBuilder(rootUrl, appsControllerFindOneByAppIdentifier.PATH, 'get');
  if (params) {
    rb.path('appIdentifier', params.appIdentifier, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<App>;
    })
  );
}

appsControllerFindOneByAppIdentifier.PATH = '/apps/appIdentifier/{appIdentifier}';
